import api from "!../node_modules/.pnpm/style-loader@2.0.0_webpack@5.94.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../node_modules/.pnpm/css-loader@5.2.7_webpack@5.94.0/node_modules/css-loader/dist/cjs.js!../node_modules/.pnpm/postcss-loader@8.2.1_postcss@8.5.28_typescript@4.9.5_webpack@5.94.0/node_modules/postcss-loader/dist/cjs.js!./tailwind.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};